// @flow
import styled, { css } from "styled-components";
import { get } from "lodash";
import buildColor from "@fdr/static-ui/ColorPalette";
import {
  defaultSize,
  fontCondensed,
  fontShentox,
  fontBold,
  fontRoboto
} from "@fdr/static-ui/Typography";

const cssByStatus = {
  SK: `
    background-color: ${buildColor("green", "500")};
    color: ${buildColor("white", "100")};
  `,
  RO: `
    background-color: ${buildColor("white", "00")};
    color: ${buildColor("grey", "D3")};
  `,
  above10: `
    background-color: ${buildColor("grey", "L3")}
    color: ${buildColor("black", "100")};
    `,
  below10: `
    background-color: ${buildColor("orange")};
    color: ${buildColor("white", "100")};
  `,
  fullDate: `
    background-color: none;
    color: ${buildColor("navy", "700")};
    font-size: 12px;
    height: 14px;
  `
};

export const MTPColorStandard = {
  result: buildColor("grey", "D3"),
  raceOff: buildColor("green"),
  closest: buildColor("orange"),
  default: buildColor("grey", "D3")
};

export const MTPColorLight = {
  result: buildColor("grey", "D3"),
  raceOff: buildColor("green"),
  closest: buildColor("orange"),
  default: buildColor("blue")
};

export const MTPColorDark = {
  result: buildColor("white"),
  raceOff: buildColor("green", "400"),
  closest: buildColor("orange"),
  default: buildColor("white")
};

export const MTPColorDerby = {
  result: buildColor("grey", "L4"),
  raceOff: buildColor("green", "L2"),
  closest: buildColor("orange", "D2"),
  default: buildColor("grey", "L4")
};

export const getMTPColor = (
  status: string,
  mode: string = "default",
  keepDefaultColor?: boolean = false
) => {
  let colours = MTPColorStandard;

  if (mode === "dark") {
    colours = MTPColorDark;
  } else if (mode === "light") {
    colours = MTPColorLight;
  } else if (mode === "derby") {
    colours = MTPColorDerby;
  }

  if (keepDefaultColor) return colours.default;

  return get(colours, status, colours.default);
};

export const Container = styled.time`
  display: flex;
  color: ${({ mtpStatus, mode, keepDefaultColor }) =>
    getMTPColor(mtpStatus, mode, keepDefaultColor)};
  text-transform: uppercase;
  ${({ isSmall, inline, condensedDescription }) =>
    isSmall
      ? css`
          align-items: start;
          align-self: ${condensedDescription ? "center" : "start"};
          ${!inline &&
          css`
            flex-flow: column;
          `}
        `
      : css`
          align-items: center;
          align-self: center;
        `}
`;

export const Timer = styled.span`
  font-weight: bold;
  letter-spacing: 1px;
  margin-right: 4px;
  ${({ isSmall, mtpStatus, inline, showDescription }) =>
    isSmall
      ? css`
          font-family: ${fontBold};
          font-weight: normal;
          font-size: ${inline || showDescription ? "14px" : "16px"};
          line-height: 18px;
          text-transform: uppercase;
          padding-top: ${inline ? "2px" : "0px"};
        `
      : css`
          font-family: ${fontShentox};
          font-size: ${mtpStatus === "raceOff" || mtpStatus === "result"
            ? "20px"
            : "36px"};
          height: ${mtpStatus === "raceOff" || mtpStatus === "result"
            ? "20px"
            : "36px"};
        `};
  ${({ isFutureBetsTab }) =>
    isFutureBetsTab &&
    css`
      font-family: ${fontRoboto};
      font-size: ${defaultSize};
      font-weight: 400;
      letter-spacing: 0px;
      color: ${buildColor("grey", "D3")};
    `}
`;

export const Description = styled.span`
  font-weight: normal;
  letter-spacing: 1px;
  font-family: ${fontCondensed};
  ${({ isSmall }) =>
    !isSmall
      ? css`
          font-size: ${defaultSize};
          height: 34px;
        `
      : css`
          font-size: 12px;
          line-height: 125%;
        `}
`;

export const CondensedDescription = styled.span`
  font-weight: normal;
  letter-spacing: 1px;
  font-family: ${fontCondensed};
  line-height: 125%;
  padding-top: 3px;
`;

export const TimerText = styled.span`
  line-height: 18px;
  padding-top: 2px;
`;

export default styled.time`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.size}px;
  font-family: ${fontCondensed};
  letter-spacing: 1px;
  text-transform: uppercase;
  height: ${({ size }) => size + 4}px;
  ${({ mtpStatus }) => css`
    ${cssByStatus[mtpStatus]}
    ${mtpStatus !== "RO" &&
    mtpStatus !== "fullDate" &&
    `padding: 0 4px;
    `}
  `};
  border-radius: 2px;
`;
